import useHasMounted from './useHasMounted'

export default function useIsInApp(isInAppFromServer?: boolean) {
  const hasMounted = useHasMounted()

  if (isInAppFromServer) {
    return true
  }

  if (!hasMounted) {
    return undefined
  }

  if (
    window.Android?.refreshBroadcast ||
    window.webkit?.messageHandlers?.refreshBroadcast
  ) {
    return true
  }

  // For some URLs, ios is rendering them into JS bridge disabled webview, fix for that
  // Reference: https://stackoverflow.com/questions/37591279/detect-if-user-is-using-webview-for-android-ios-or-a-regular-browser
  const userAgent = window.navigator.userAgent.toLowerCase(),
    safari = userAgent.includes('safari'),
    ios = /iphone|ipod|ipad/.test(userAgent)
  if (ios) {
    if (!safari) {
      return true
    }
  }

  return false
}
